'use client'

import Link from "next/link"
import { Accordion, AccordionItem, Listbox, ListboxItem } from "@heroui/react"
import { PLUGINS } from "./plugins"

const PluginList = [...PLUGINS].sort((a, b) => a.name.localeCompare(b.name))

export default function PluginsList() {
  return (
    <Accordion isCompact>
      <AccordionItem key="1" aria-label="Server Plugins" title="Server Plugins">
        <Listbox aria-label="Server Plugins" variant="flat">
          {PluginList.map((plugin) => (
            <ListboxItem key={plugin.name} as={Link} href={plugin.url} description={plugin.short} target="_blank">
              {plugin.name}
            </ListboxItem>
          ))}
        </Listbox>
      </AccordionItem>
    </Accordion>
  )
}
